<template>
  <div>
    <b-card title="Треки без файлов">
      <b-overlay
          :show="isLoading"
          rounded="sm"
      >
        <b-table
            ref="refTracksListTable"
            :items="tracks"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="Нет треков"
            class="position-relative"
        >

          <!-- Column: Artists -->
          <template #cell(artists)="data">
            <span v-for="(artist, index) in data.item.artists" :key="artist.id">
              <b-link
                  v-if="artist.id"
                  :to="{ name: 'artist-view', params: { id: artist.id }}"
                  class="font-weight-bold"
              >
                {{ artist.title }}
              </b-link>
              <span v-if="index < data.item.artists.length - 1"> / </span>
            </span>
          </template>

          <!-- Column: YouTube Cache -->
          <template #cell(has_yt_cache)="data">
            <feather-icon
                :icon="data.item.has_yt_cache ? 'CheckCircleIcon' : 'XCircleIcon'"
                :class="data.item.has_yt_cache ? 'text-success' : 'text-danger'"
                size="20"
            />
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <span class="text-nowrap">
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  class="btn-icon"
                  :to="{name: 'track-search', params: { id: data.item.id }}"
              >
                <feather-icon icon="DownloadIcon"/>
              </b-button>
            </span>
          </template>
        </b-table>

        <b-pagination
            v-if="total > perPage"
            v-model="page"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BLink,
  BOverlay,
  BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import musicStoreModule from "@/views/db-music/musicStoreModule";
import {onUnmounted, ref, watch} from "@vue/composition-api";
import {useToast} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BLink,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
  },
  setup() {
    const STORE_MODULE_NAME = 'missing-tracks'
    const toast = useToast()

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, musicStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const tracks = ref([])
    const isLoading = ref(false)
    const page = ref(1)
    const perPage = ref(50)
    const total = ref(0)

    const tableColumns = [
      {key: 'id', label: '#', sortable: false},
      {key: 'artists', label: 'Исполнитель', sortable: false},
      {key: 'track', label: 'Название', sortable: false},
      {key: 'has_yt_cache', label: 'YouTube Cache', sortable: false},
      {key: 'actions', label: 'Действия'},
    ]

    const fetchMissingTracks = async () => {
      isLoading.value = true
      try {
        const res = await store.dispatch('missing-tracks/fetchMissingTracks', {
          page: page.value,
          per_page: perPage.value,
        })
        tracks.value = res.data.data
        total.value = res.data.total
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ошибка загрузки треков',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        isLoading.value = false
      }
    }

    watch([page], () => {
      fetchMissingTracks()
    })

    fetchMissingTracks()

    return {
      tracks,
      isLoading,
      tableColumns,
      page,
      perPage,
      total,
    }
  },
}
</script>